import React, { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Button from '../Form/Button';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

// Lets the pharmacist record a debt a patient already owed before the pharmacy started using
// Saydalani (e.g. tracked on paper). It becomes a SOLDE_INITIAL entry on the patient's account
// ledger, counts toward "reste dû" right away, and can be settled through the existing
// "Nouvelle facture" flow like any other debt (see PatientAccountService/OrderService).
export default function PatientAccountEntryModal({ show, onClose, onSaved, patientId }) {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (data) => {
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/v1/patients/${patientId}/account-entries`, {
                type: 'SOLDE_INITIAL',
                amount: data.amount,
                label: data.label || 'Solde initial (reporté)',
            }, { withCredentials: true });
            toast.success('Solde initial ajouté.');
            onSaved?.();
            onClose();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Une erreur est survenue.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            id="patientAccountEntryModal"
            title="Solde initial"
            show={show}
            onClose={onClose}
            icon={faFileInvoiceDollar}
            iconBg="#fff7ed"
            iconColor="#d97706"
            footer={
                <Button
                    isLoading={loading}
                    loadingMessage="Enregistrement…"
                    className="btn btn-primary w-100"
                    type="submit"
                    form="patientAccountEntryForm"
                >
                    Ajouter la dette
                </Button>
            }
        >
            <Form id="patientAccountEntryForm" onSubmit={handleSubmit}>
                <div className="cdm-section" style={{ marginBottom: 0 }}>
                    <p className="cdm-section__label">Dette antérieure au logiciel</p>
                    <div className="mb-2">
                        <span className="cdm-field-label">Montant <span className="text-danger">*</span></span>
                        <div className="cdm-price-wrapper">
                            <InputText
                                name="amount"
                                placeholder="0.00"
                                validationRules={{
                                    required: 'Le montant est requis',
                                    min: { value: 0.01, message: 'Le montant doit être positif' },
                                }}
                            />
                            <span className="cdm-price-badge">Dhs</span>
                        </div>
                    </div>
                    <div>
                        <span className="cdm-field-label">Note (optionnel)</span>
                        <InputText name="label" placeholder="Ex : Reporté du cahier papier" />
                    </div>
                </div>
            </Form>
        </Modal>
    );
}
